import { homApi } from '~/redux/apis/hom'
import { TutorLevel, TutorPackage } from '~/types/booking'

import { BookingProducts, ProductAPI, PRODUCT_CATEGORY, GetProductRequest, CampaignProducts } from '~/types/product'

import formatTutoringProductPrices from '../utils/formatTutoringProductPrices'

export const productApi = homApi.injectEndpoints({
  endpoints: (build) => ({
    getProducts: build.query<BookingProducts, GetProductRequest>({
      query: (params: GetProductRequest) => {
        return {
          url: '/v3/products',
          method: 'GET',
          params,
        }
      },
      transformResponse: (response: ProductAPI[]) => {
        const modifiedResponse = response.map((prod) => {
          return {
            ...prod,
            tutorLevel: prod.mentorLevel,
          }
        })

        const videoChatProduct = modifiedResponse.find((product) => product.category === PRODUCT_CATEGORY.VIDEO_CHAT)
        const tutoringProducts = modifiedResponse.filter(
          (product) => product.category === PRODUCT_CATEGORY.PRIVATE_TUTORING,
        )

        const formattedTutoringProducts = formatTutoringProductPrices(tutoringProducts)
        const lowestHourlyPriceProduct = formattedTutoringProducts.find(
          (product) => product.type === TutorPackage.HOURS_64 && product.tutorLevel === TutorLevel.TUTOR,
        )

        return {
          tutoringProducts: formattedTutoringProducts,
          videoChatProduct,
          lowestHourlyPriceProduct,
        }
      },
    }),
    getCampaignProducts: build.query<CampaignProducts[], { campaignId: number; campaignsOnly: boolean }>({
      query: (params) => ({
        url: '/v3/products',
        method: 'GET',
        params,
      }),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProductsQuery, useLazyGetProductsQuery, useGetCampaignProductsQuery } = productApi
